export default "__VITE_ASSET__CIWLmIfo__"